<div class="password_rules_check__container" *transloco="let t">
  <p>{{ t('password-check-component.meet-criteria') }}</p>
  <ul>
    @for (rule of rules; track rule) {
      <li>
        <div>
          <span>[{{ rule.value }}] {{ labelForRuleType(rule.rule_type) }}</span>
          <div [ngClass]="validForRule(rule) ? 'done' : 'hide'">
            <xi-icon icon="checkmark" color="success" iconSize="large"></xi-icon>
          </div>
        </div>
      </li>
    }
  </ul>
  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [height]="150" [width]="150" [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
</div>
